import React from 'react';
import Table from '../../../Components/Ui/Table';
import ActionDropdown from '../../../Components/Ui/ActionDropdown';
import { Edit2, Trash2 } from 'lucide-react';
import Badge from '../../../Components/Ui/Badge';
// import { Link } from "react-router-dom";

const getStatusBadge = (status) => {
  switch (status) {
    case 'inactive':
      return <Badge variant="error">Inactive</Badge>;
    default:
      return <Badge variant="success">Active</Badge>;
  }
};

const ProductTable = ({ products, onEdit, onDelete, onToggleStatus }) => {
  return (
    <Table
      className="w-full"
      columns={[
        {
          header: 'Product Name',
          accessor: (row) => (
            <span
              className="block max-w-[100px] truncate whitespace-nowrap overflow-hidden cursor-pointer"
              title={row?.productDetails?.title}
            >
              {row?.productDetails?.title || 'N/A'}
            </span>
          ),
          className: 'w-[15%] min-w-[150px]',
        },
        { header: 'Brand', accessor: (row) => row?.brandDetails?.name || 'N/A' },
        { header: 'Category', accessor: (row) => row?.categoryDetails?.name },
        {
          header: 'Product Code',
          accessor: (row) => row?.productDetails?.productCode,
          className: 'text-center',
        },
        {
          header: 'MRP',
          accessor: (row) => `₹${row?.productDetails?.mrp}`,
          className: 'text-center',
        },
        {
          header: 'Selling Price',
          accessor: (row) => <span className="text-green-500">{`₹${row?.sellerPrice}`}</span>,
          className: 'text-center',
        },
        {
          header: 'Status',
          accessor: (row) => getStatusBadge(row.status),
          className: 'text-center',
        },
        {
          header: 'Actions',
          accessor: (row) => (
            <ActionDropdown
              actions={[
                {
                  label: 'Edit',
                  icon: Edit2,
                  onClick: () => onEdit(row),
                },
                {
                  label: 'Delete',
                  icon: Trash2,
                  onClick: () => onDelete(row._id),
                },
                // {
                //   label: row.status === 'active' ? 'Deactivate' : 'Activate',
                //   icon: Power,
                //   onClick: () => onToggleStatus(row),
                // },
              ]}
            />
          ),
        },
      ]}
      data={products}
      keyExtractor={(row) => row._id}
    />
  );
};

export default ProductTable;
